import { connect } from 'react-redux';
import KelasKhusus from '../../../views/Akademi/DataKelas/KelasKhusus.view';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(KelasKhusus);
